import styled from 'styled-components';

import { UiInput } from '../ui-kit';

export const StyledDebouncedInput = styled(UiInput)`
  color: rgba(0, 0, 0, 0.5);
`;
